module.exports = __webpack_public_path__ + "assets/img/events-point-06.e3eb1945.png";